import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import {
  Home,
  User,
  Ticket,
  LayoutDashboard,
  LogOut,
  Sparkles,
} from "lucide-react";
import { LogoutUserFunc } from "../../../redux/actions/User";

function linkClass(isActive) {
  return `flex items-center gap-3 px-4 py-3 rounded-xl text-sm transition-all w-full ${
    isActive
      ? "bg-red-600/10 text-red-500 border border-red-600/20"
      : "text-white/60 hover:bg-white/5 hover:text-white border border-transparent"
  }`;
}

function SidebarNavItem({ icon: Icon, label, isActive, onClick, to }) {
  if (to) {
    return (
      <NavLink
        to={to}
        onClick={onClick}
        className={({ isActive: routeActive }) => linkClass(routeActive)}
        style={{ fontWeight: 500 }}
      >
        <Icon className="w-4 h-4 shrink-0" strokeWidth={1.8} />
        <span>{label}</span>
      </NavLink>
    );
  }

  return (
    <button type="button" className={linkClass(isActive)} onClick={onClick}>
      <Icon className="w-4 h-4 shrink-0" strokeWidth={1.8} />
      <span style={{ fontWeight: isActive ? 600 : 500 }}>{label}</span>
    </button>
  );
}

export default function Sidebar({ active, setactive }) {
  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <aside
      className="hidden lg:flex flex-col w-64 shrink-0 bg-[#0d1117] border-r border-red-600/10 lg:static lg:z-auto lg:sticky lg:top-16 lg:self-start lg:min-h-[calc(100vh-4rem)]"
      style={{ fontFamily: "'Outfit', 'Inter', sans-serif" }}
    >
      <nav className="flex-1 p-6 space-y-1 overflow-y-auto">
        <SidebarNavItem icon={Home} label="Home" to="/" onClick={() => {}} />
        <SidebarNavItem
          icon={User}
          label="Account Details"
          isActive={active === 2}
          onClick={() => setactive(2)}
        />
        <SidebarNavItem icon={Ticket} label="My Tickets" to="/my-tickets" onClick={() => {}} />
        <SidebarNavItem
          icon={Sparkles}
          label={user?.capabilities?.creator && user.capabilities.creator !== "REJECTED" ? "Creator dashboard" : "Promote & earn"}
          to={user?.capabilities?.creator && user.capabilities.creator !== "REJECTED" ? "/creators/dashboard" : "/creators"}
          onClick={() => {}}
        />
        {user?.role === "admin" && (
          <SidebarNavItem
            icon={LayoutDashboard}
            label="Admin Dashboard"
            to="/admin/dashboard"
            onClick={() => {}}
          />
        )}
        {(user?.capabilities?.host || user?.userType === "organizer" || user?.role === "admin") && (
          <SidebarNavItem
            icon={LayoutDashboard}
            label="My Dashboard"
            isActive={active === 4}
            onClick={() => setactive(4)}
          />
        )}
      </nav>

      <div className="p-4 border-t border-red-600/10">
        <button
          type="button"
          onClick={() => dispatch(LogoutUserFunc(navigate))}
          className="flex items-center gap-3 px-4 py-3 rounded-xl text-sm text-white/40 hover:text-red-500 hover:bg-red-500/5 transition-all w-full border border-transparent"
        >
          <LogOut className="w-4 h-4 shrink-0" strokeWidth={1.8} />
          <span style={{ fontWeight: 500 }}>Logout</span>
        </button>
      </div>
    </aside>
  );
}
